export const yearHeader: any[] = ['1', '5', '10']

export const storiesPerPage = [
    { value: 25 },
    { value: 50 },
    { value: 75 }
];
export const familiesSortingItems: any[] = [
    {
        key: 1,
        text: "Latest Updated (A to Z)",
        param: [{ sort_by: 'updated_time' }],
    },
    {
        key: 2,
        text: "Latest Updated (Z to A)",
        param: [{ sort_by: 'updated_time' }, { reverse: 'True' }],
    },
    {
        key: 3,
        text: "Family Name (A to Z)",
        param: [{ sort_by: 'family_name' }],
    },
    {
        key: 4,
        text: "Family Name (Z to A)",
        param: [{ sort_by: 'family_name' }, { reverse: 'True' }],
    }
];

export const breakdowntypeHeader = {
    "State": ["By State", "By District"],
    "District": ["By District", "By Sub District", "By Pincode"],
    "Sub District": ["By Sub District"
        , "By Pincode"
    ],
    "Village": ["By Villages"]
    // "Pin Code": ["By Pin Code"]
}
export const graphValues = [
    {
        "y_axis": [
            "No Data",
            "Low",
            "Medium",
            "High"
        ],
        "x_axis": [
            2019,
            2020,
            2021,
            2022,
            2023,
            2024
        ],
        "data": [
            {
                "year": 2021,
                "value": "Low",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
            },
            {
                "year": 2022,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            },
            {
                "year": 2023,
                "value": "Low",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
            },
            {
                "year": 2024,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            }
        ],
        "avg_data": [
            {
                "year": 2021,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
            },
            {
                "year": 2022,
                "value": "Low",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            },
            {
                "year": 2023,
                "value": "Low",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
            },
            {
                "year": 2024,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            }
        ],
    },
    {
        "y_axis": [
            "Low",
            "Medium",
            "High"
        ],
        "x_axis": [
            '2021',
            '2022*',
            '2023',
            '2024'
        ],
        "data": [
            {
                "year": 2021,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            },
            {
                "year": 2023,
                "value": "Low",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
            },
            {
                "year": 2024,
                "value": "High",
                "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
            }
        ],
        "avg_data": [
            {
                "year": 2021,
                "value": "Low",
            },
            {
                "year": 2023,
                "value": "Low",
            },
            {
                "year": 2024,
                "value": "High",
            },
        ],
    }
];

export const presenceYears = [
    {
        "value": 2011,
    },
    {
        "value": 2012,
    },
    {
        "value": 2013,
    },
    {
        "value": 2014,
    },
    {
        "value": 2015,
    },
    {
        "value": 2016,
    },
    {
        "value": 2017,
    },
    {
        "value": 2018,
    },
    {
        "value": 2019,
    },
    {
        "value": 2020,
    },
    {
        "value": 2021,
    },
    {
        "value": 2022,
    }
];

export const iButtonText = {
    "homePage": {
        "leftPanel": {
            "eh": "Entrepreneurial Households (EH) are the bedrock of the EPIC Opportunity, and represent the quantum of customers with a propensity to spend on high priority goods and assets.",
            "poi": "Points of Interest (PoI) refer to establishments across 50 sub-categories and 8 categories that have been identified as hotspots for Entrepreneurial Household and/or Core Transaction Value activity. ",
            "ctv": "Core Transaction Value (CTV) is EPIC World’s unique metric to better understand and measure the economic vibrancy of Entrepreneurial Households. ",
            "categories": "Refine your insights by choosing from 50 PoI sub-categories across 8 main categories to personalize your view.\n\nA PoI would belong to only one category, but might belong to more than one sub-category.",
            // "myBusinessPresence": "View your company's locations on the map. \n\nOnly members of your company can view these locations",
            "myBusinessPresence": "View your business presence on the map. Data points have been categorized based on your inputs provided to EPIC Intelligence.\n\nOnly members of your company can view these locations",
            "spotlight": "Real stories from the field help put the numbers in the right context",
            "topDistricts": {
                "PoI": "Top regions ranked by your selected data layers",
                "CTV": "Top regions ranked by your selected data layers",
                "EH": "Top regions ranked by your selected data layers",
            },
            "topsubDistricts": {
                "PoI": "Top regions ranked by your selected data layers",
                "CTV": "Top regions ranked by your selected data layers",
                "EH": "Top regions ranked by your selected data layers",
            },
            "DataLayer": "Combined score from normalized layers. Locations with incomplete data are excluded.",
            "brandLens": "Highlight certain Points of Interest using a text search on PoI names. This could be specific brands, sub-categories, or type that you can use a keyword to describe. For example ‘HDFC’, ‘School’, ‘Medical’ etc. This is useful to understand the market landscape, ecosystem maturity, and competitor dynamics at hyper-local granularity."
        },
        "cif": {
            "india": "Methodology -\n\nTotal Population: The estimate is derived from an analysis performed by EPIC World from Kontur dataset for population published in November 2023\n\nNumber of Households: The estimate is derived from the people per household ratio (4.3) shared in NFHS - 5 by MoHFW, Indian Government",
            "totalAddressableMarket": "We present the EPIC opportunity created by the entrepreneurial households.\n\nMethodology -\n\nTAM: The estimate is derived from an analysis performed by Praxis Global Alliance\n\nAverage Annual CTV: The estimate is derived from an analysis performed by Praxis Global Alliance\n\nNumber of EH: The estimate is derived from an empirical cut on number of households based on 50+ years of field experience to identify industrious communities",
            "pointsOfInterest": "A curated set of verified digital Points of Interest published on Google Maps from 50 subcategories under the primary 8 categories below that EPIC World believes represents either strong EH, strong CTV signals, or both. The PoI counts listed below are unique.",
            "districtsCovered": "Coverage is defined by the presence of Points of Interest data for a district. We will keep expanding our coverage in the coming months.\n\nExercise caution with state-level comparisons, as district coverage varies across states.",
            "coreTransactionValue": "We present the EPIC Opportunity created by the Entrepreneurial Households (EH).\n\nMethodology \nCTV: The estimate is derived from an analysis performed by Praxis Global Alliance.\n\nAverage Annual CTV: The estimate is derived from an analysis performed by Praxis Global Alliance.\n\nNumber of EH: The estimate is derived from an empirical cut on number of households based on 50+ years of field experience to identify industrious communities."

        },
    },
    "dashboardPage": {
        "leftPanel": {
            "districtsCovered": "Coverage is defined by the presence of Points of Interest data for a district. We will keep expanding our coverage in the coming months.\n\nExercise caution with state-level comparisons, as district coverage varies across states."
        },
        "yourWorldview": {
            "leadingCategory": "The Leading Category is defined as the one that has the highest ratio of the number of Points of Interest (PoIs) in that category for a specific location, compared to the average number of PoIs in the same category across locations at the same level within the region.\n\nIn your custom view, we present the Leading Category from your PoI category selection",
            "fastestGrowingSubCategory": "The Fastest Growing Sub-Category is the sub-category with the highest growth in the past 5 years (2020-2024)\n\nIn your custom view, we present the Fastest Growing Sub-Category from your PoI sub-category selection",
            "leadingState": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location from your PoI sub-category selection",
            "leadingDistrict": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location from your PoI sub-category selection",
            "leadingSubDistrict": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location from your PoI sub-category selection",
            "leadingPinCode": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location from your PoI sub-category selection",
            "leadingVillage": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location from your PoI sub-category selection",
            "stateWiseBreakdown": "Here’s an overview of the geographical units that define this location.",
            "districtWiseBreakdown": "Here’s an overview of the geographical units that define this location.",
            "growthOfPoisOverTimeForSubDistricts": "Compare the growth of an underlying location with this location. \nSince growth rates are based on varying base values, they may look unusually high or low when viewed across longer time periods.",
            "poiBreakdown": "The breakdown of Points of Interest in a location speaks to the penetration of different Core Solutions in the location."
        },
        "overallTakeaway": {
            "leadingCategory": "The Leading Category is defined as the one that has the highest ratio of the number of Points of Interest (PoIs) in that category for a specific location, compared to the average number of PoIs in the same category across locations at the same level within the region.\n\nIn this view, we present the Leading Category across all 8 categories.",
            "leadingSubCategory": "The Leading Sub-Category is defined as the one that has the highest ratio of the number of Points of Interest (PoIs) in that sub-category for a specific location, compared to the average number of PoIs in the same sub-category across locations at the same level within the region.\n\nIn this view, we present the Leading Sub-Category across all 50 sub-categories.",
            "fastestGrowingCategory": "The Fastest Growing Category is the category with the highest growth in the past 5 years (2020-2024)\n\nIn this view, we present the Fastest Growing Category across all 8 categories",
            "fastestGrowingSubCategory": "The Fastest Growing Sub-Category is the category with the highest growth in the past 5 years (2020-2024)\n\nIn this view, we present the Fastest Growing Sub-Category across all 50 sub-categories",
            "categoryWiseBreakdown": "Analyze the distribution of Points of Interest (PoIs) across eight categories recognized as reliable indicators of on-ground economic vibrancy."
        },
        "deepDiveIntoEachCategory": {
            "poiCount": "Unique number of PoIs in this Category",
            "leadingSubCategory": "The Leading Sub-Category is defined as the one that has the highest ratio of the number of Points of Interest (PoIs) in that sub-category for a specific location, compared to the average number of PoIs in the same sub-category across locations at the same level within the region.\n\nIn this view, we present the Leading Sub-Category in this Category",
            "fastestGrowingSubCategory": "The Fastest Growing Sub-Category is the category with the highest growth in the past 5 years (2020-2024)\n\nIn this view, we present the Fastest Growing Sub-Category in this Category",
            "leadingState": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location for this Category",
            "leadingDistrict": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location for this Category",
            "leadingSubDistrict": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location for this Category",
            "leadingPinCode": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location for this Category",
            "leadingVillage": "A Leading Location is defined as the underlying geographical unit that has the highest ratio of the number of Points of Interest (PoIs) across your PoI selection, compared to the average number of PoIs in the same selection across locations at the same level within the region.\n\nIn your custom view, we present the Leading Location for this Category",
            "growthOfPoisOverTimeForHealthcare": "The growth chart is plotted on a subset of PoIs based on the accessibility of the last review date of their Google Map markers.\n Since growth rates are based on varying base values, they may look unusually high or low when viewed across longer time periods.",
            "breakdownOfHealthcarePoiBySubCategory": "The breakdown of Points of Interest in a location speaks to the penetration of different sub-categories in this category for this location",
            "growthOfPoisOverTimeBySubCategory": "The growth chart is plotted on a subset of PoIs based on the accessibility of the last review date of their Google Map markers.\n Since growth rates are based on varying base values, they may look unusually high or low when viewed across longer time periods."
        }
    },
    "comparePage": {
        'PoIDeepDive': "The growth chart is plotted on a subset of PoIs based on the accessibility of the last review date of their Google Map markers.\nSince growth rates are based on varying base values, they may look unusually high or low when viewed across longer time periods."
    }
}

export const MBP_data = {
    "data": [
        {
            "presence_type": "Branch",
            "count": 17,
            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch.svg",
            "footer_data": [
                {
                    "type": "Performance",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                        }
                    ]
                },
                {
                    "type": "Growth",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Growth_Branch.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Growth_Branch.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Growth_Branch.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Growth_Branch.svg"
                        }
                    ]
                }
            ],
            "presence_data": [
                {
                    "presence_id": "ChIJ7_CgYaMpAzoR02rpO2pgGno",
                    "presence_name": "EPIC World Contai - I Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Low_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2011,
                    "end_date": "Present",
                    "associated_presence": [
                        {
                            "name": "abc",
                            "Status": "active"
                        },
                        {
                            "name": "abc",
                            "Status": "active"
                        }
                    ]
                },
                {
                    "presence_id": "ChIJ22AJn6dtXjkRKLne8jJJXd4",
                    "presence_name": "EPIC World Kapadvanj Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Medium_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2014,
                    "end_date": "Present",
                    "associated_presence": [
                        {
                            "name": "abc",
                            "Status": "active"
                        },
                        {
                            "name": "abc",
                            "Status": "active"
                        }
                    ]
                },
                {
                    "presence_id": "ChIJ4R458fUR7TkRuDVQSqitDJE",
                    "presence_name": "EPIC World Musahri Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Medium_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2014,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ02HmdMA7qzsRh9AUhynd_-w",
                    "presence_name": "EPIC World Tittakudi Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Branch_High_Performance_Low_Growth.svg",
                    "status": "Closed",
                    "start_date": 2014,
                    "end_date": 2015,
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ-bP_QnIn5zsRnLulD40PBAQ",
                    "presence_name": "EPIC World Dahanu Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2015,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3x7MP_qxrDsRuN1IPStJc2c",
                    "presence_name": "EPIC World Kandachipuram Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2015,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3-3h1Pk9UTkR1x32i7Vugls",
                    "presence_name": "EPIC World Mandvi Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_No Data_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2016,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ55dOC7ub9TkR0OJZD_3sLag",
                    "presence_name": "EPIC World Kuchai Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_High_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ7_Yxfn_RuDsROuut0xVSKCQ",
                    "presence_name": "EPIC World HUBBALLI URBAN Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Medium_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ57IRUMApzjsRZwj4hxNvhC4",
                    "presence_name": "EPIC World Nanded Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Medium_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2019,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ1e7aOUR7UjoRM6LDwz3RYi8",
                    "presence_name": "EPIC World Ponneri Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Low_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2020,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ2dKJDEUNSjoRJVUjd06s1Us",
                    "presence_name": "EPIC World Chebrolu Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2021,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3WxAksTVdDkRnrWdAi2iQIo",
                    "presence_name": "EPIC World Sahaswan Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Low_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2021,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ2WrGNCWlNzoRoHK77ZNQ3L4",
                    "presence_name": "EPIC World Rajahmundry (Urban) Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_Low_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3xeMSjMjrDsR6JkRHJgftG0",
                    "presence_name": "EPIC World Pennagaram Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_High_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ4XfhsPKlIjoRZvhY6yrDSWc",
                    "presence_name": "EPIC World BUGUDA Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Branch_No Data_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2023,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ7Q3RJ62jczkRZstbNlsv4Zs",
                    "presence_name": "EPIC World Bharatpur Branch",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Branch_Low_Performance_Medium_Growth.svg",
                    "status": "Closed",
                    "start_date": 2025,
                    "end_date": 2025,
                    "associated_presence": []
                }
            ]
        },
        {
            "presence_type": "Partner",
            "count": 17,
            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner.svg",
            "footer_data": [
                {
                    "type": "Performance",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Partner.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Partner.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Partner.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Partner.svg"
                        }
                    ]
                },
                {
                    "type": "Growth",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Growth_Partner.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Growth_Partner.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Growth_Partner.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Growth_Partner.svg"
                        }
                    ]
                }
            ],
            "presence_data": [
                {
                    "presence_id": "ChIJ27Rl7T0tjjkRO_bvndPQbuQ",
                    "presence_name": "EPIC World Sadar Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Medium_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2012,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ0-KSTWz_-DkRsTb_CMwCjkI",
                    "presence_name": "EPIC World Manteswar Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2013,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ112UcmblGzoR48cAKx1xrAw",
                    "presence_name": "EPIC World Jajapur Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_High_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2013,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ4cMr2NnpzDsRBd4pcI9il8s",
                    "presence_name": "EPIC World Bejjanki Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2014,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ-8cuqifdxzsRnGc2VFOjVn0",
                    "presence_name": "EPIC World TALIKOTI Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2016,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ58S-r9Ur9DkRH4e_dofX_Dc",
                    "presence_name": "EPIC World Jaipur Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2016,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ-8n_Y7ZVFjkR0zkxk5n0mhU",
                    "presence_name": "EPIC World Sadulshahar Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ18QTk-nR2jsRQFWKKgnVXLU",
                    "presence_name": "EPIC World Georai Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_High_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2018,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ7fXoxf4zEzkR233kRxX0X7Q",
                    "presence_name": "EPIC World Udaipurwati Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Partner_Low_Performance_High_Growth.svg",
                    "status": "Closed",
                    "start_date": 2019,
                    "end_date": 2021,
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ-RdqsEbzwDsR1WATgwk1MQ0",
                    "presence_name": "EPIC World NIPPANI Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2020,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ47iSQUwRoDkRUzw05NG1Om4",
                    "presence_name": "EPIC World Nawabganj Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2021,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ113B2hc1kzkRrkDmQd1sySo",
                    "presence_name": "EPIC World Motihari Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ17TmrQ_XyTsR5ETGxpif57A",
                    "presence_name": "EPIC World Raichur Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3bHIedrncjkR0dH6slIf3r8",
                    "presence_name": "EPIC World Nagar Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ3wLsIMwHqTsRRif8CqjrkZc",
                    "presence_name": "EPIC World TiruppurNorth Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_No Data_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ65fimc1GCzkRSti7l3yD3ac",
                    "presence_name": "EPIC World Anupshahr Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2024,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ6YgA7dkZ0DsRigNE1-35Erg",
                    "presence_name": "EPIC World Parbhani Partner",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Partner_Low_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2024,
                    "end_date": "Present",
                    "associated_presence": []
                }
            ]
        },
        {
            "presence_type": "Relationship Manager",
            "count": 16,
            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager.svg",
            "footer_data": [
                {
                    "type": "Performance",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Relationship Manager.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Relationship Manager.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Relationship Manager.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Relationship Manager.svg"
                        }
                    ]
                },
                {
                    "type": "Growth",
                    "values": [
                        {
                            "text": "High",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/High_Growth_Relationship Manager.svg"
                        },
                        {
                            "text": "Medium",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Growth_Relationship Manager.svg"
                        },
                        {
                            "text": "Low",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Growth_Relationship Manager.svg"
                        },
                        {
                            "text": "No Data",
                            "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Growth_Relationship Manager.svg"
                        }
                    ]
                }
            ],
            "presence_data": [
                {
                    "presence_id": "ChIJ05xWFnVDXDkRskBYDM9yZas",
                    "presence_name": "EPIC World Mahesana Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2012,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ51xrkZrdEjkRwEMPzebRr8Y",
                    "presence_name": "EPIC World SURAJGARH Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_Medium_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2013,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ6w2-J8pksTsRVHQUQbHLqeE",
                    "presence_name": "EPIC World Puttaparthi Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_No Data_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2013,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ12uhO6pHkzkR4Eka6Uskigc",
                    "presence_name": "EPIC World Sugauli Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Relationship Manager_Low_Performance_Low_Growth.svg",
                    "status": "Closed",
                    "start_date": 2016,
                    "end_date": 2018,
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ2wfxX-ZBPToRdFOQBLYUCsM",
                    "presence_name": "EPIC World Ichchapuram Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ378MLnJxrjsRzqXPRIfvSTU",
                    "presence_name": "EPIC World Hosur Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ4w6D6fHqNzoRrfT5vSBuytk",
                    "presence_name": "EPIC World Kothapeta Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_Low_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2017,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ-f__v5fuDzkRzmAhmAMz3w8",
                    "presence_name": "EPIC World SAS Nagar (Mohali) Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_Low_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2018,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ66_uNvvLuzsRSLTuupMuko4",
                    "presence_name": "EPIC World Honnali Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2019,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ38Yes_AT2zsR3LAiMzn7v-s",
                    "presence_name": "EPIC World Paithan Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Relationship Manager_Low_Performance_High_Growth.svg",
                    "status": "Closed",
                    "start_date": 2020,
                    "end_date": 2022,
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ1-p0Vb68XDkR3G45VnckIuU",
                    "presence_name": "EPIC World Deesa Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2021,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ29dHlUcq8zkRp-giYi-qfIw",
                    "presence_name": "EPIC World Gaya Town C.D.Block Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_Medium_Performance_Medium_Growth.svg",
                    "status": "Active",
                    "start_date": 2022,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ52cmCKShkTkRtESg_DhPmlQ",
                    "presence_name": "EPIC World Sagri Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Closed_Relationship Manager_Low_Performance_No Data_Growth.svg",
                    "status": "Closed",
                    "start_date": 2022,
                    "end_date": 2023,
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ5cE9SeUnvzsR_XJGiwSCkH8",
                    "presence_name": "EPIC World Haliyal Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_No Data_Performance_Low_Growth.svg",
                    "status": "Active",
                    "start_date": 2023,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ66pqNW-hzjsRxVGKbB0AcgY",
                    "presence_name": "EPIC World Regode Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_Medium_Performance_High_Growth.svg",
                    "status": "Active",
                    "start_date": 2024,
                    "end_date": "Present",
                    "associated_presence": []
                },
                {
                    "presence_id": "ChIJ75hWehrC5zsR87qNRE-4Y4M",
                    "presence_name": "EPIC World Panvel Relationship Manager",
                    "icon": "https://storage.googleapis.com/epic_intelligence_resources/icons/Active_Relationship Manager_High_Performance_No Data_Growth.svg",
                    "status": "Active",
                    "start_date": 2024,
                    "end_date": "Present",
                    "associated_presence": []
                }
            ]
        }
    ]
}

export const compareTableData = [
    {
        "tableHeaderData": [
            {
                "label": "Rank"
            },
            {
                "label": "District"
            },
            {
                "label": "Area (sq.km.)"
            },
            {
                "label": "Population"
            },
            {
                "label": "EH",
                "children": [
                    { "label": "EH" },
                    { "label": "EH A" },
                    { "label": "EH B" }
                ]
            },
            {
                "label": "CTV (₹)",
                "children": [
                    { "label": "CTV (₹)" },
                    { "label": "CTV A" },
                    { "label": "CTV B" }
                ]
            },
            {
                "label": "PoI",
                "children": [
                    { "label": "PoI" },
                    { "label": "PoI A" },
                    { "label": "PoI B" },
                    { "label": "PoI C" }
                ]
            }
        ],
        "tableData": [

            {
                "geoId": '',
                "rank": 1,
                "geoName": "Odisha",
                "area": "1.70 L",
                "actualArea": 17828899508.7,
                "population": "4.82 Cr",
                "actualPopulation": 4816726,
                "eh": "86.5 L",
                "actaulEh": 8645407,
                "ctv": "23,72,895 Cr",
                "actualCtv": 23728950000.0,
                "poiCount": "86,837",
                "actualPoiCount": 86837,
                "myPresence": 16,
                "color": '#ABD9AB',
                "presence_types": [
                    {
                        "name": "Branch",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg",
                        "properties": {
                            "count": 4
                        }
                    },
                    {
                        "name": "Relationship Manager",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg",
                        "properties": {
                            "count": 8
                        }
                    },
                    {
                        "name": "Partner",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg",
                        "properties": {
                            "count": 4
                        }
                    }
                ]
            },
            {
                "geoId": '',
                "rank": 1,
                "geoName": "Odisha",
                "area": "1.78 L",
                "actualArea": 178288995012.7,
                "population": "4.82 Cr",
                "actualPopulation": 48167266,
                "eh": "86.5 L",
                "actaulEh": 8645407,
                "ctv": "23,72,895 Cr",
                "actualCtv": 23728950000000.0,
                "poiCount": "86,837",
                "actualPoiCount": 86837,
                "myPresence": 16,
                "color": '#C0E3C0',
                "presence_types": [
                    {
                        "name": "Branch",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg",
                        "properties": {
                            "count": 4
                        }
                    },
                    {
                        "name": "Relationship Manager",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg",
                        "properties": {
                            "count": 8
                        }
                    },
                    {
                        "name": "Partner",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg",
                        "properties": {
                            "count": 4
                        }
                    }
                ]
            },
            {
                "geoId": '',
                "rank": 1,
                "geoName": "Odisha",
                "area": "1.78 L",
                "actualArea": 178288995012.7,
                "population": "4.82 Cr",
                "actualPopulation": 48167266,
                "eh": "86.5 L",
                "actaulEh": 8645407,
                "ctv": "23,72,895 Cr",
                "actualCtv": 23728950000000.0,
                "poiCount": "86,837",
                "actualPoiCount": 86837,
                "myPresence": 16,
                "color": '#C0E3C0',
                "presence_types": [
                    {
                        "name": "Branch",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg",
                        "properties": {
                            "count": 4
                        }
                    },
                    {
                        "name": "Relationship Manager",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg",
                        "properties": {
                            "count": 8
                        }
                    },
                    {
                        "name": "Partner",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg",
                        "properties": {
                            "count": 4
                        }
                    }
                ]
            },
            {
                "geoId": '',
                "rank": 1,
                "geoName": "Odisha",
                "area": "1.78 L",
                "actualArea": 178288995012.7,
                "population": "4.82 Cr",
                "actualPopulation": 48167266,
                "eh": "86.5 L",
                "actaulEh": 8645407,
                "ctv": "23,72,895 Cr",
                "actualCtv": 23728950000000.0,
                "poiCount": "86,837",
                "actualPoiCount": 86837,
                "myPresence": 16,
                "color": '#C0E3C0',
                "presence_types": [
                    {
                        "name": "Branch",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg",
                        "properties": {
                            "count": 4
                        }
                    },
                    {
                        "name": "Relationship Manager",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg",
                        "properties": {
                            "count": 8
                        }
                    },
                    {
                        "name": "Partner",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg",
                        "properties": {
                            "count": 4
                        }
                    }
                ]
            },

        ]
    },
    {
        "tableHeaderData": [
            {
                "label": "Rank"
            },
            {
                "label": "District"
            },
            {
                "label": "Area (sq.km.)"
            },
            {
                "label": "Population"
            },
            {
                "label": "EH",
                "children": [
                    { "label": "EH A" },
                    { "label": "EH B" }
                ]
            },
            {
                "label": "PoI",
                "children": [
                    { "label": "PoI A" },
                    { "label": "PoI B" },
                    { "label": "PoI C" }
                ]
            }
        ],
        "tableData": [

            {
                "geoId": '',
                "rank": 1,
                "geoName": "Odisha",
                "poiCoverage": "13 / 30",
                "area": "1.78 L",
                "actualArea": 178288995012.7,
                "population": "4.82 Cr",
                "actualPopulation": 48167266,
                "eh": "86.5 L",
                "actaulEh": 8645407,
                "poiCount": "86,837",
                "actualPoiCount": 86837,
                "myPresence": 16,
                "color": '',
                "presence_types": [
                    {
                        "name": "Branch",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg",
                        "properties": {
                            "count": 4
                        }
                    },
                    {
                        "name": "Relationship Manager",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg",
                        "properties": {
                            "count": 8
                        }
                    },
                    {
                        "name": "Partner",
                        "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg",
                        "properties": {
                            "count": 4
                        }
                    }
                ]
            },

        ]
    }
]

export const presenceDetailsData = {
    "total_count": "540",
    "title": "My Business Presence",
    "isDisabled": "partial",
    "presences": [
        {
            "name": "Branch",
            "count": "170",
            "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Branch.svg"
        },
        {
            "name": "Relationship Manager",
            "count": "186",
            "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Relationship Manager.svg"
        },
        {
            "name": "Partner",
            "count": "184",
            "icon": "https://storage.googleapis.com/epic_intelligence_resources_dev/icons/Active_Partner.svg"
        }
    ]
};
export const kpiValues = {
    "breakdownType": "State",
    "data": [
        {
            "type": "EhData",
            "title": "Entrepreneurial (EH)",
            "count": "24.7 Cr",
            "isDisabled": "partial",
            "cardData": [
                {
                    "count": "24.7 Cr",
                    "unit": null,
                    "title": "Entrepreneurial Households (EH)",
                    "rank": null,
                    "icon": "work"
                },
                {
                    "count": "62.5",
                    "unit": " / sq.km.",
                    "title": "EH/Area",
                    "rank": null,
                    "icon": "person_pin_circle"
                }
            ]
        },
        {
            "type": "cTVData",
            "title": "Core Transaction Value (CTV)",
            "count": "₹8,16,07,500 Cr",
            "isDisabled": "complete",
            "cardData": [
                {
                    "count": "₹8,16,07,500 Cr",
                    "unit": null,
                    "title": "Core Transaction Value (CTV)",
                    "rank": null,
                    "icon": "percent"
                },
                {
                    "count": "₹33 L",
                    "unit": null,
                    "title": "CTV/EH",
                    "rank": null,
                    "icon": "patient_list"
                },
                {
                    "count": "₹79,68,24,000 Cr",
                    "unit": null,
                    "title": "Projected CTV by 2043",
                    "rank": null,
                    "icon": "show_chart"
                }
            ]
        },
        {
            "type": "poiData",
            "title": "Selected PoI",
            "count": "24.5 L",
            "isDisabled": "notDisabled",
            "cardData": [
                {
                    "count": "24.5 L",
                    "title": "Selected PoI",
                    "rank": null,
                    "icon": "my_location"
                },
                {
                    "count": "24.5 L",
                    "title": "Total PoI",
                    "rank": null,
                    "icon": "location_searching"
                }
            ]
        }
    ]
}

export const metricDropdown = [
    {
        "key": "poi",
        "label": "PoI"
    },
    {
        "key": "poiByEh",
        "label": "PoI/EH"
    },
    {
        "key": "poiByArea",
        "label": "PoI/Area (sq.km)"
    },
]

export const dropdownData = {
    states: [
        {
            "geoId": 30,
            "geoName": "Andaman & Nicobar",
            "geotype": "state",
            "ctvcount": "9.2 Bn",
            "poicount": null,
            "coverage": "--",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        },
        {
            "geoId": 16,
            "geoName": "Andhra Pradesh",
            "geotype": "state",
            "ctvcount": "652 Bn",
            "poicount": "200 K",
            "coverage": "22/26",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        },
        {
            "geoId": 29,
            "geoName": "Arunachal Pradesh",
            "geotype": "state",
            "ctvcount": "46.2 Bn",
            "poicount": null,
            "coverage": "--",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        }
    ],
    districts: [
        {
            "geoId": 115,
            "geoName": "Bagalkote",
            "geotype": "district",
            "ctvcount": "12.9 Bn",
            "poicount": "10.3 K",
            "coverage": "9/9",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        },
        {
            "geoId": 728,
            "geoName": "Ballari",
            "geotype": "district",
            "ctvcount": "15.2 Bn",
            "poicount": "5.75 K",
            "coverage": "5/5",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        },
        {
            "geoId": 623,
            "geoName": "Bidar",
            "geotype": "district",
            "ctvcount": "11.4 Bn",
            "poicount": "9.22 K",
            "coverage": "8/8",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        }
    ],
    sub_districts: [
        {
            "geoId": 1589082,
            "geoName": "Anakapalle",
            "geotype": "village",
            "poicount": "761",
            "coverage": "--",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        },
        {
            "geoId": 1588921,
            "geoName": "Batajangalapalem",
            "geotype": "village",
            "poicount": "5",
            "coverage": "--",
            "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
            ],
        }
    ],
    villages: []
}

export const villagesData = {
    geoType: 'Villages',
    items: [
        {
            id: 1,
            name: 'Mapusa',
            location: 'Panjim City',
            code: '403507',
            hasTriangle: true,
            hasCircle: true
        },
        {
            id: 2,
            name: 'Margao',
            location: 'Margao Town',
            code: '403601',
            hasTriangle: false,
            hasCircle: true
        },
        {
            id: 3,
            name: 'Ponda',
            location: 'Ponda City',
            code: '403401',
            hasTriangle: false,
            hasCircle: false
        },
        {
            id: 4,
            name: 'Vasco da Gama',
            location: 'Vasco City',
            code: '403802',
            hasTriangle: true,
            hasCircle: true
        },
        {
            id: 5,
            name: 'Bardez',
            location: 'Bardez Town',
            code: '403511',
            hasTriangle: true,
            hasCircle: false
        },
        {
            id: 6,
            name: 'Salcete',
            location: 'Salcete Town',
            code: '403602',
            hasTriangle: false,
            hasCircle: false
        },
        {
            id: 7,
            name: 'Sanguem',
            location: 'Sanguem City',
            code: '403705',
            hasTriangle: false,
            hasCircle: true
        },
        {
            id: 8,
            name: 'Quepem',
            location: 'Quepem Town',
            code: '403703',
            hasTriangle: true,
            hasCircle: true
        }
    ]
};

export const districtData = [
    {
        "geo_id": 30,
        "name": "Andaman & Nicobar",
        "geo_level": 2,
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ],
        "sub_regions": [
            {
                "geo_id": 224,
                "name": "Nicobars",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
            },
            {
                "geo_id": 602,
                "name": "North  & Middle Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
            },
            {
                "geo_id": 785,
                "name": "South Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"],

            }
        ]
    },
    {
        "geo_id": 30,
        "name": "Andaman & Nicobar",
        "geo_level": 2,
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"],
        "sub_regions": [
            {
                "geo_id": 224,
                "name": "Nicobars",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"],
            },
            {
                "geo_id": 602,
                "name": "North  & Middle Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"],
            },
            {
                "geo_id": 785,
                "name": "South Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
            }
        ]
    },
    {
        "geo_id": 30,
        "name": "Andaman & Nicobar",
        "geo_level": 2,
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"


        ],
        "sub_regions": [
            {
                "geo_id": 224,
                "name": "Nicobars",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"],
            },
            {
                "geo_id": 602,
                "name": "North  & Middle Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"

                ],
            },
            {
                "geo_id": 785,
                "name": "South Andaman",
                "geo_level": 3,
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"

                ],

            }
        ]
    }
]

export const villages = [
    {
        "geoId": 1113091,
        "geoName": "Bijnor Rural",
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ],
        "parent": ["Bijnor", "UP"]
    },
    {
        "geoId": 1112995,
        "geoName": "Bijnor Ahatmi",
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ],
        "parent": ["Bijnor", "UP"]
    },
    {
        "geoId": 1112995,
        "geoName": "Bijnor Ahatm- Uttar Pradesh (UP)",
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ],
        "parent": ["Bijnor", "UP"]
    },
    {
        "geoId": 1144564,
        "geoName": "Bijnor",
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ],
        "parent": ["Bijnor", "UP"]
    },
]

export const topDistrictsData = [
    {
        geoName: 'Bangalore',
        geoId: 586,
        parent: {
            geoName: 'Karnataka',
            geoId: 11
        },
        // "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        // ]
    },
    {
        geoName: 'Bidar',
        geoId: 623,
        parent: {
            geoName: 'Karnataka',
            geoId: 11
        },
        // "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
        //     "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        // ]
    },
    {
        geoName: 'Alluri Sitharama Raju',
        geoId: 423,
        parent: {
            geoName: 'Andhra Pradesh',
            geoId: 16
        },
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ]
    },
    {
        geoName: 'Anakapalli',
        geoId: 460,
        parent: {
            geoName: 'Andhra Pradesh',
            geoId: 16
        },
        "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
            "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
        ]
    }
]

export const searchData = [
    {
        "geotype": "States",
        "data": [
            {
                "geoId": 37,
                "geoName": "Uttar Pradesh",
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [37]
            },
            {
                "geoId": 26,
                "geoName": "Uttarakhand",
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [26]
            }
        ]
    },
    {
        "geotype": "Districts",
        "data": [
            {
                "geoId": 169,
                "geoName": "Uttara Kannada",
                "parents": [{
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [11, 169]
            },
            {
                "geoId": 79,
                "geoName": "Uttarkashi",
                "parent": [{
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [11, 79]
            },
            {
                "geoId": 507,
                "geoName": "Uttar Bastar Kanker",
                "parent": [{
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [11, 507]
            },
            {
                "geoId": 54,
                "geoName": "Uttar Dinajpur",
                "parent": [{
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [11, 54]
            }
        ]
    },
    {
        "geotype": "Sub-districts",
        "data": [
            {
                "geoId": 6542,
                "geoName": "Uttara P.S",
                "parents": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ],
                "hierarchy": [
                    24,
                    366,
                    6542
                ]
            }
        ]
    },
    {
        "geotype": "Villages",
        "data": [
            {
                "geoId": 1225769,
                "geoName": "Uttarwarikol",
                "parents": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "pincode": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ]
            },
            {
                "geoId": 1225769,
                "geoName": "Uttarwarikol",
                "parents": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "pincode": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ]
            },
            {
                "geoId": 1225769,
                "geoName": "Uttarwarikol",
                "parents": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "pincode": [{
                    "geoId": 586,
                    "geoName": "Bangalore"
                },
                {
                    "geoId": 11,
                    "geoName": "Karnataka"
                }],
                "images": ["https://storage.googleapis.com/epic_intelligence_resources/icons/High_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Medium_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/Low_Performance_Branch.svg",
                    "https://storage.googleapis.com/epic_intelligence_resources/icons/No Data_Performance_Branch.svg"
                ]
            },
        ]
    }


]